/**
 * <s-back-to-top> — Floating "back to top" control.
 *
 * Required child markup:
 *   button[commandfor=<this id>][command="--top"] — Scrolls the page back to the top.
 *
 * The element stays hidden until the shopper scrolls past `data-threshold` pixels (default 600).
 */
class BackToTop extends HTMLElement {
  #threshold = 600;
  #ticking = false;
  #reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  connectedCallback() {
    this.#threshold = Number(this.dataset.threshold) || 600;
    this.addEventListener('command', this.#handleCommand);
    window.addEventListener('scroll', this.#handleScroll, { passive: true });
    this.#update();
  }

  disconnectedCallback() {
    this.removeEventListener('command', this.#handleCommand);
    window.removeEventListener('scroll', this.#handleScroll);
  }

  #handleCommand = (event) => {
    if (event.command !== '--top') return;
    window.scrollTo({ top: 0, behavior: this.#reducedMotion.matches ? 'auto' : 'smooth' });
    document.getElementById('main-content')?.focus({ preventScroll: true });
  };

  #handleScroll = () => {
    if (this.#ticking) return;
    this.#ticking = true;
    requestAnimationFrame(() => {
      this.#update();
      this.#ticking = false;
    });
  };

  #update() {
    this.toggleAttribute('data-visible', window.scrollY > this.#threshold);
  }
}

if (!customElements.get('s-back-to-top')) {
  customElements.define('s-back-to-top', BackToTop);
}
